import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';

/**
 * An element that wraps the entire window, houses `SideInterface` and `BodyInterface`.
 */
var BodyInterface = function (_a) {
    var style = _a.style, children = _a.children;
    return (React.createElement("div", { className: "flex flex-auto flex-row relative", style: style }, children));
};

/* Returns ` t` if truthy, or an empty string otherwise. */
var valEmpty = function (t, v) {
    return t ? " ".concat(v) : "";
};
/* Returns ` v` if `t` is truthy, or ` w` otherwise. */
var valOr = function (t, v, w) {
    return t ? " ".concat(v) : " ".concat(w);
};

/*
 * Primary button style used within the main interface of dashboards.
 */
var ButtonPrimary = function (_a) {
    var colorSecondary = _a.colorSecondary, disabled = _a.disabled, grow = _a.grow, iconLeft = _a.iconLeft, iconRight = _a.iconRight, iconTransform = _a.iconTransform, onClick = _a.onClick, lg = _a.lg, marginLeft = _a.marginLeft, marginRight = _a.marginRight, marginX = _a.marginX, style = _a.style, text = _a.text;
    return (React.createElement(motion.button, { whileHover: { scale: !disabled ? 1.02 : 1 }, whileTap: { scale: !disabled ? 0.98 : 1 }, className: "btn-layout " +
            "btn-common " +
            "btn-icons " +
            "btn-primary" +
            valOr(lg, "lg", "sm") +
            valEmpty(colorSecondary, "secondary-color") +
            valEmpty(grow, "grow") +
            valEmpty(marginRight, "m-right") +
            valEmpty(marginLeft, "m-left") +
            valEmpty(marginX, "m-x"), style: style, type: "button", disabled: disabled, onClick: function () {
            if (typeof onClick == "function") {
                onClick();
            }
        } },
        iconLeft ? (React.createElement(FontAwesomeIcon, { icon: iconLeft, className: valOr(text, "icon-left", undefined), transform: valOr(iconTransform, iconTransform, undefined) })) : null,
        text ? text : null,
        iconRight ? (React.createElement(FontAwesomeIcon, { icon: iconRight, className: valOr(text, "icon-right", undefined), transform: valOr(iconTransform, iconTransform, undefined) })) : null));
};

/*
 * Secondary button style used within the main interface of dashboards.
 */
var ButtonSecondary = function (_a) {
    var disabled = _a.disabled, grow = _a.grow, iconLeft = _a.iconLeft, iconRight = _a.iconRight, iconTransform = _a.iconTransform, lg = _a.lg, onClick = _a.onClick, marginLeft = _a.marginLeft, marginRight = _a.marginRight, marginX = _a.marginX, style = _a.style, text = _a.text;
    return (React.createElement("button", { className: "btn-layout " +
            "btn-common " +
            "btn-icons " +
            "btn-secondary" +
            valOr(lg, "lg", "sm") +
            valEmpty(grow, "grow") +
            valEmpty(marginRight, "m-right") +
            valEmpty(marginLeft, "m-left") +
            valEmpty(marginX, "m-x"), style: style, type: "button", disabled: disabled, onClick: function () {
            if (typeof onClick == "function") {
                onClick();
            }
        } },
        iconLeft ? (React.createElement(FontAwesomeIcon, { icon: iconLeft, className: valOr(text, "icon-left", undefined), transform: valOr(iconTransform, iconTransform, undefined) })) : null,
        text ? text : null,
        iconRight ? (React.createElement(FontAwesomeIcon, { icon: iconRight, className: valOr(text, "icon-right", undefined), transform: valOr(iconTransform, iconTransform, undefined) })) : null));
};

/*
 * Invert button style used in modals.
 */
var ButtonInvert = function (_a) {
    var disabled = _a.disabled, grow = _a.grow, iconLeft = _a.iconLeft, iconRight = _a.iconRight, iconTransform = _a.iconTransform, onClick = _a.onClick, marginLeft = _a.marginLeft, marginRight = _a.marginRight, marginX = _a.marginX, style = _a.style, text = _a.text;
    return (React.createElement(motion.button, { whileHover: { scale: !disabled ? 1.02 : 1 }, whileTap: { scale: !disabled ? 0.98 : 1 }, className: "btn-layout " +
            "btn-common " +
            "btn-icons " +
            "btn-invert" +
            valEmpty(grow, "grow") +
            valEmpty(marginRight, "m-right") +
            valEmpty(marginLeft, "m-left") +
            valEmpty(marginX, "m-x"), style: style, type: "button", disabled: disabled, onClick: function () {
            if (typeof onClick == "function") {
                onClick();
            }
        } },
        iconLeft ? (React.createElement(FontAwesomeIcon, { icon: iconLeft, className: valOr(text, "icon-left", undefined), transform: valOr(iconTransform, iconTransform, undefined) })) : null,
        text ? text : null,
        iconRight ? (React.createElement(FontAwesomeIcon, { icon: iconRight, className: valOr(text, "icon-right", undefined), transform: valOr(iconTransform, iconTransform, undefined) })) : null));
};

/*
 * Invert rounded button style used in modals.
 */
var ButtonInvertRounded = function (_a) {
    var disabled = _a.disabled, grow = _a.grow, iconLeft = _a.iconLeft, iconRight = _a.iconRight, iconTransform = _a.iconTransform, lg = _a.lg, onClick = _a.onClick, marginLeft = _a.marginLeft, marginRight = _a.marginRight, marginX = _a.marginX, style = _a.style, text = _a.text;
    return (React.createElement("button", { className: "btn-layout " +
            "btn-common " +
            "btn-icons " +
            "btn-invert-rounded" +
            valEmpty(grow, "grow") +
            valOr(lg, "lg", "sm") +
            valEmpty(marginRight, "m-right") +
            valEmpty(marginLeft, "m-left") +
            valEmpty(marginX, "m-x"), style: style, type: "button", disabled: disabled, onClick: function () {
            if (typeof onClick == "function") {
                onClick();
            }
        } },
        iconLeft ? (React.createElement(FontAwesomeIcon, { icon: iconLeft, className: valOr(text, "icon-left", undefined), transform: valOr(iconTransform, iconTransform, undefined) })) : null,
        text ? text : null,
        iconRight ? (React.createElement(FontAwesomeIcon, { icon: iconRight, className: valOr(text, "icon-right", undefined), transform: valOr(iconTransform, iconTransform, undefined) })) : null));
};

/*
 * Submit button style used within modals to submit transactions.
 */
var ButtonSubmit = function (_a) {
    var colorSecondary = _a.colorSecondary, disabled = _a.disabled, grow = _a.grow, iconLeft = _a.iconLeft, iconRight = _a.iconRight, iconTransform = _a.iconTransform, onClick = _a.onClick, marginLeft = _a.marginLeft, marginRight = _a.marginRight, marginX = _a.marginX, style = _a.style, text = _a.text;
    return (React.createElement(motion.button, { whileHover: { scale: !disabled ? 1.02 : 1 }, whileTap: { scale: !disabled ? 0.98 : 1 }, className: "btn-layout " +
            "btn-common " +
            "btn-icons " +
            "btn-submit" +
            valEmpty(colorSecondary, "secondary-color") +
            valEmpty(grow, "grow") +
            valEmpty(marginRight, "m-right") +
            valEmpty(marginLeft, "m-left") +
            valEmpty(marginX, "m-x"), style: style, type: "button", disabled: disabled, onClick: function () {
            if (typeof onClick == "function") {
                onClick();
            }
        } },
        iconLeft ? (React.createElement(FontAwesomeIcon, { icon: iconLeft, className: valOr(text, "icon-left", undefined), transform: valOr(iconTransform, iconTransform, undefined) })) : null,
        text ? text : null,
        iconRight ? (React.createElement(FontAwesomeIcon, { icon: iconRight, className: valOr(text, "icon-right", undefined), transform: valOr(iconTransform, iconTransform, undefined) })) : null));
};

export { BodyInterface, ButtonInvert, ButtonInvertRounded, ButtonPrimary, ButtonSecondary, ButtonSubmit };
